import script from "./ScrollPane.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollPane.vue?vue&type=script&setup=true&lang=js"

import "./ScrollPane.vue?vue&type=style&index=0&id=4766db3d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4766db3d"]])

export default __exports__